export default __webpack_public_path__ + "static/media/userThree.748fee5f.svg";